import { useMemo } from 'react';
import { useAppSelector } from 'redux/hooks';

/**
 * @deprecated Only use for Legacy Manual pricing, do not use for the new Shopify Pricing hooks.
 */
const useBillingState = () => {
    const { activeSubscriptions, plans, fetching } = useAppSelector((state) => state.billing);

    const isLoading = useMemo(() => fetching, [fetching]);

    return { activeSubscriptions, plans, isLoading };
};

export default useBillingState;
